import { config } from 'config';
import type { Author } from './types';

const base = config.apiBaseUrl;

function getJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    return res.json().then(
      (body: { message?: string; code?: string }) => {
        throw new Error(body.message ?? `HTTP ${res.status}`);
      },
      () => {
        throw new Error(`HTTP ${res.status}`);
      }
    );
  }
  return res.json();
}

export async function searchAuthors(query: string, limit?: number): Promise<Author[]> {
  const search = new URLSearchParams();
  search.set('q', query);
  if (limit != null) search.set('limit', String(limit));
  const res = await fetch(`${base}/authors/search?${search.toString()}`, { credentials: 'include' });
  return getJson<Author[]>(res);
}

export async function createAuthor(name: string): Promise<Author> {
  const res = await fetch(`${base}/authors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name }),
  });
  return getJson<Author>(res);
}
